import { RolePermission } from '../../helpers/permissions';

// Пермиссии, которые обязательно учитываются при формировании стейта матрицы
export const CONSIDERED_MATRIX_ROLE_PERMISSIONS: RolePermission[] = [
    RolePermission.CAMERA,
    RolePermission.CAMERA_MUTE,
    RolePermission.MICROPHONE,
    RolePermission.MICROPHONE_MUTE,
    RolePermission.DESKTOP,
    RolePermission.DESKTOP_MUTE,
    RolePermission.CLOSE_ROOM,
    RolePermission.RECORDING,
    RolePermission.RECORDING_MUTE,
    RolePermission.ADMIT,
    RolePermission.ACCESS_LEVEL_EDIT,
    RolePermission.CLOUD_RECORDING,
    RolePermission.SUMMARIZATION,
    RolePermission.SUMMARIZATION_RECEIVE,
    RolePermission.CALENDAR_SUMMARIZATION_RECEIVE,
    RolePermission.CONFERENCE_PERMISSIONS_EDIT_MATRIX,
];
